import { useTranslation } from 'react-i18next';

export const useLangField = () => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  return (obj, baseKey) => {
    if (!obj || !baseKey) return undefined;
    const langKey =
      {
        ru: `${baseKey}Ru`,
        kk: `${baseKey}Kk`,
      }[language] || `${baseKey}Ru`;
    return obj[langKey];
  };
};
